import React from 'react';
import "../template-file-css/document-file-template.css";


export const RFS_PsyEvalTemplateAlleva = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='RFS_PsyEvalTemplateAlleva' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <span className='eleHeader'>Chief Complaint:</span>
                    <textarea id='txtChiefComplaint' name='txtChiefComplaint' className='add-only'></textarea><br />
                    HPI: Pt is a presenting to establish OP psychiatric care with a referral from t</p>

                <p className='w-750'><h4>MEDICAL HISTORY</h4></p>

                <p className='w-750'>
                    <span className='eleHeader'>Allergies:</span>
                    <textarea id='txtAllergies' name='txtAllergies' className='add-only'></textarea> 
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Past/current medical problems: </span>
                    <textarea id='txtPastCurrentMedicalProblems' name='txtPastCurrentMedicalProblems' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Current non-psychiatric medications: </span>
                    <textarea id='txtCurrentNonPsychiatricMedications' name='txtCurrentNonPsychiatricMedications' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>OTC, vitamins or supplements: </span>
                    <textarea id='txtVitaminsOrSupplements' name='txtVitaminsOrSupplements' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Surgical History:</span>
                    <textarea id='txtSurgicalHistory' name='txtSurgicalHistory' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>History of seizures:</span>
                    <textarea id='txtHistoryOfSeizures' name='txtHistoryOfSeizures' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>History of head trauma or LOC:</span>
                    <textarea id='txtHistoryHeadTrauma' name='txtHistoryHeadTrauma' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Developmental History:</span>
                    <textarea id='txtDevelopmentalHistory' name='txtDevelopmentalHistory' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Women's Health:</span>
                    <textarea id='txtWomenHealth' name='txtWomenHealth' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>LMP:</span>
                    <textarea id='txtLmp' name='txtLmp' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Birth Control:</span>
                    <textarea id='txtBirthControl' name='txtBirthControl' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Pregnancy History:</span>
                    <textarea id='txtPregnancyHistory' name='txtPregnancyHistory' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>PCP:</span>
                    <textarea id='txtPcp' name='txtPcp' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Pharmacy:</span>
                    <textarea id='txtPharmacy' name='txtPharmacy' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Labs:</span>
                    <textarea id='txtLabs' name='txtLabs' className='add-only'></textarea>
                </p>

                <p className='w-750'><h4>PSYCHIATRIC HISTORY</h4></p>

                <p className='w-750'>
                    <span className='eleHeader'>Professional Dx Hx:</span>
                    <textarea id='txtProfessional' name='txtProfessional' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Hospitalizations:</span>
                    <textarea id='txtHospitalizations' name='txtHospitalizations' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Residential Treatment: </span>
                    <textarea id='txtPesidentialTreatment' name='txtPesidentialTreatment' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Outpatient Psychiatric Treatment:</span>
                    <textarea id='txtOutpatientPsychiatricTreatment' name='txtOutpatientPsychiatricTreatment' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Outpatient Therapy: </span>
                    <textarea id='txtOutpatientTherapy' name='txtOutpatientTherapy' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Current Psychiatric Medications: </span>
                    <textarea id='txtCurrentPsyhiatricMedications' name='txtCurrentPsyhiatricMedications' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Past Medications Trials (medications, responses, reason for d/c):</span>
                    <textarea id='txtPastMedicationsTrials' name='txtPastMedicationsTrials' className='add-only'></textarea>
                </p>

                <p className='w-750'><h4>FAMILY PSYCHIATRIC HISTORY</h4></p>

                <p className='w-750'>
                    <span className='eleHeader'>Known Mental Illness in the Family:</span>
                    <textarea id='txtKnownMentalIllenssInTheFamily' name='txtKnownMentalIllenssInTheFamily' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Alcohol or Substance Abuse in the family: </span>
                    <textarea id='txtAlcoholSubstanceAbuseFamily' name='txtAlcoholSubstanceAbuseFamily' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Family Psychiatric Hospitalizations:</span>
                    <textarea id='txtFamilyPsychiatricHospitalizations' name='txtFamilyPsychiatricHospitalizations' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Suicide within the family:</span>
                    <textarea id='txtSuicideWithinTheFamily' name='txtSuicideWithinTheFamily' className='add-only'></textarea>
                </p>


                <p className='w-750'><h4>SOCIAL HISTORY</h4></p>

                <p className='w-750'>
                    <span className='eleHeader'>Born:</span>
                    <textarea id='txtBorn' name='txtBorn' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Current living situation:</span>
                    <textarea id='txtCurrentLivingSituation' name='txtCurrentLivingSituation' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Birth Order/Siblings:</span>
                    <textarea id='txtBirthOrderSiblings' name='txtBirthOrderSiblings' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Marital Status/Romantic Relationships: </span>
                    <textarea id='txtMaritalStatusRomanticRelationships' name='txtMaritalStatusRomanticRelationships' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Children: </span>
                    <textarea id='txtChildren' name='txtChildren' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Friends:</span>
                    <textarea id='txtFriends' name='txtFriends' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Hobbies:</span>
                    <textarea id='txtHobbies' name='txtHobbies' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Occupation/Income Source: </span>
                    <textarea id='txtOccupationIncomeSource' name='txtOccupationIncomeSource' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Education: </span>
                    <textarea id='txtEducation' name='txtEducation' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Learning Disabilities:</span>
                    <textarea id='txtLearningDisabilities' name='txtLearningDisabilities' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Current/Past Military Service:</span>
                    <textarea id='txtCurrentPastMilitaryService' name='txtCurrentPastMilitaryService' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Arrested/Jailed/Imprisoned: </span>
                    <textarea id='txtArrestedJailedImprisoned' name='txtArrestedJailedImprisoned' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Legal Issues:</span>
                    <textarea id='txtLegalIssues' name='txtLegalIssues' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Religion/Spiritual Practice: </span>
                    <textarea id='txtReligionSpiritualPractice' name='txtReligionSpiritualPractice' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Stressors:</span>
                    <textarea id='txtStressors' name='txtStressors' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Exercise:</span>
                    <textarea id='txtExercise' name='txtExercise' className='add-only'></textarea>
                </p>

                <p className='w-750'><h4>SUBSTANCE ABUSE/TREATMENT HISTORY </h4>
                    <span className='small'>(including in-utero exposure)</span></p>

                <p className='w-750'>
                    <span className='eleHeader'>Alcohol:</span>
                    <span className='small'>How many drinks a week? When was your last drink? </span>
                    <textarea id='txtAlcohol' name='txtAlcohol' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Tobacco/Nicotine: </span>
                    <textarea id='txtTobaccoNicotine' name='txtTobaccoNicotine' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Caffeine:</span>
                    <span className='small'> Drink any coffee or energy drinks? </span>
                    <textarea id='txtCaffeine' name='txtCaffeine' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Amphetamines: </span>
                    <textarea id='txtAmphetamines' name='txtAmphetamines' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Benzodiazepines: </span>
                    <textarea id='txtBenzodiazepines' name='txtBenzodiazepines' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Cannabis:</span>
                    <textarea id='txtCannabis' name='txtCannabis' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Cocaine:</span>
                    <textarea id='txtCocaine' name='txtCocaine' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Hallucinogens:</span>
                    <textarea id='txtHallucinogens' name='txtHallucinogens' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Narcotic Pain Medication:</span>
                    <textarea id='txtNarcoticPainMedication' name='txtNarcoticPainMedication' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Opiates:</span>
                    <textarea id='txtOpiates' name='txtOpiates' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Longest Period of Sobriety:</span>
                    <textarea id='txtLongestPeriodOfSobriety' name='txtLongestPeriodOfSobriety' className='add-only'></textarea> <br />

                    Denies known in-utero exposure to drugs or alcohol</p>

                <p className='w-750'><h4>PSYCHIATRIC ROS:</h4></p>


                <p className='w-750'>
                    <span className='eleHeader'>Depression:</span>
                    <textarea id='txtDepression' name='txtDepression' className='add-only'></textarea> <br />
                    1. Reports symptoms of depression since . His symptoms include . <br />
                    <textarea id='txtDepression_1' name='txtDepression_1' className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>2. Rating:</span>
                    <span className='small'>/10 (10 is worst)</span>
                    <textarea id='txtRating' name='txtRating' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>3. Pleasure/Interest: </span>
                    <textarea id='txtOpiates' name='txtOpiates' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>4. Guilt/hopelessness: </span>
                    <textarea id='txtGuiltHopelessness' name='txtGuiltHopelessness' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>5. Concentration:</span>
                    <textarea id='txtConcentration' name='txtConcentration' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>6 .Appetite:</span>
                    <textarea id='txtAppetite' name='txtAppetite' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>7 .Sleep:</span>
                    <textarea id='txtSleep' name='txtSleep' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>8 .Psychomotor agitation or retardation:</span>
                    <textarea id='txtPsychomotorAgitation' name='txtPsychomotorAgitation' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>9 .SI:</span>
                    <textarea id='txtSi' name='txtSi' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>10 HI:</span>
                    <textarea id='txtHi' name='txtHi' className='add-only'></textarea> <br />
                    Anxiety: Reports symptoms of anxiety since </p>

                <p className='w-750'>
                    <span className='eleHeader'>11. How many days a week?</span>
                    <textarea id='txtHowManyDaysWeek' name='txtHowManyDaysWeek' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>12. Rating: /10 (10 is worst)</span>
                    <span className='w-small'>/10 (10 is worst)</span>
                    <textarea id='txtRating_1' name='txtRating_1' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>13. Restlessness:</span>
                    <textarea id='txtRestlessness' name='txtRestlessness' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>1. Irritability/anger: Any angry outbursts or irritability? </span>
                    <textarea id='txtIrritability' name='txtIrritability' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>2. Aggression:</span>
                    <textarea id='txtAggression' name='txtAggression' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>3. Poor concentration:</span>
                    <textarea id='txtPoorConcentration' name='txtPoorConcentration' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>4. Muscle tension:</span>
                    <textarea id='txtMuscleTension' name='txtMuscleTension' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>5. Racing thoughts:</span>
                    <textarea id='txtRacingThoughts' name='txtRacingThoughts' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>6. Insomnia:</span>
                    <textarea id='txtInsomnia' name='txtInsomnia' className='add-only'></textarea>
                    <br />
                    Obsessions/Compulsions: Denies obsessive thoughts or compulsive behaviors. </p>

                <p className='w-750'>
                    <span className='eleHeader'>Panic Disorder: Denies history of panic attacks. </span>
                    <textarea id='txtPanicDisorderDenies' name='txtPanicDisorderDenies' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>When was your last panic attack?</span>
                    <textarea id='txtWhenWasYourLastPanicAttack' name='txtWhenWasYourLastPanicAttack' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>16. Chest tightness/discomfort/pain</span>
                    <textarea id='txtChestTightnessDiscomfortPain' name='txtChestTightnessDiscomfortPain' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>17. Tachycardia/heart pounding:</span>
                    <textarea id='txtTachycardiaHeartPounding' name='txtTachycardiaHeartPounding' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>18. Feeling of choking</span>
                    <textarea id='txtFeelingOfChoking' name='txtFeelingOfChoking' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>19. SOB:</span>
                    <textarea id='txtSob' name='txtSob' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>20. Parasthesias/chills or heat sensations/numbness or tingling</span>
                    <textarea id='txtParasthesiasChillsHeatSensations' name='txtParasthesiasChillsHeatSensations' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>21. GI distress</span>
                    <textarea id='txtGiDistress' name='txtGiDistress' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>22. Light headedness/dizziness</span>
                    <textarea id='txtLightHeadenessDizziness' name='txtLightHeadenessDizziness' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>23. Shaking</span>
                    <textarea id='txtShaking' name='txtShaking' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>24. Agoraphobia/fear of dying</span>
                    <textarea id='txtAgoraphobiaFearOfDying' name='txtAgoraphobiaFearOfDying' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Phobias: Denies</span>
                    <textarea id='txtPhobiasDenies' name='txtPhobiasDenies' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>25. Mania: Denies history of mania or hypomania.</span>
                    <textarea id='txtManiaDeniesHistoryOfMania' name='txtManiaDeniesHistoryOfMania' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>26. Distractibility</span>
                    <textarea id='txtDistractibility' name='txtDistractibility' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>27. Grandiosity</span>
                    <textarea id='txtGrandiosity' name='txtGrandiosity' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>28. Flight of ideas</span>
                    <textarea id='txtFlightOfIdeas' name='txtFlightOfIdeas' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>29. Increased goal-directed activity</span>
                    <textarea id='txtIncreasedGoalDirectedActivity' name='txtIncreasedGoalDirectedActivity' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>30. Sleep. Have you ever gone days without sleep? </span>
                    <textarea id='txtSleepHaveYouEverGoneDaysWithout' name='txtSleepHaveYouEverGoneDaysWithout' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>31. Talkativeness </span>
                    <textarea id='txtTalkativeness' name='txtTalkativeness' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>32. Behaviors</span>
                    <textarea id='txtBehaviors' name='txtBehaviors' className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>33. Overall mood</span>
                    <textarea id='txtOverallMood' name='txtOverallMood' className='add-only'></textarea>
                    <br />
                    Disordered Eating: Denies history of binging, purging, or restricting.</p>

                <p className='w-750'>
                    <span className='eleHeader'>34. Binging:</span>
                    <textarea id='txtBinging' name='txtBinging' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>35. Purging:</span>
                    <textarea id='txtPurging' name='txtPurging' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>36. Restricting:</span>
                    <textarea id='txtRestricting' name='txtRestricting' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>37. Body image distortion</span>
                    <textarea id='txtBodyImageDistortion' name='txtBodyImageDistortion' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>38. Significant weight loss or gain</span>
                    <textarea id='txtSignificantWeightLossOrGain' name='txtSignificantWeightLossOrGain' className='add-only'></textarea>
                </p>

                <p className='w-750'><h4>ADHD:</h4></p>

                <p className='w-750'>
                    <span className='eleHeader'>39. Inattention</span>
                    <textarea id='txtInattention' name='txtInattention' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>40. Focus</span>
                    <textarea id='txtFocus' name='txtFocus' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>41. Able to complete challenging tasks:</span>
                    <textarea id='txtAbleCompleteChallenging' name='txtAbleCompleteChallenging' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>42. Forgetfulness:</span>
                    <textarea id='txtForgetfullness' name='txtForgetfullness' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>43. Fidgeting and restlessness:</span>
                    <textarea id='txtFidgetingAndRestlessness' name='txtFidgetingAndRestlessness' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>44. Talkativeness/impulsivity:</span>
                    <textarea id='txtTalkativenessImpulsivity' name='txtTalkativenessImpulsivity' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>45. Academic performance:
                    </span>
                    <textarea id='txtAcademicPerformance' name='txtAcademicPerformance' className='add-only'></textarea>
                    <br />
                    Psychosis: Denies symptoms of psychosis including A/V hallucinations.</p>

                <p className='w-750'>
                    <span className='eleHeader'>46. Delusions:</span>
                    <textarea id='txtDelusions' name='txtDelusions' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>47. Paranoia:</span>
                    <textarea id='txtParanoia' name='txtParanoia' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>48. Ideas of reference:</span>
                    <textarea id='txtIdeasOfReference' name='txtIdeasOfReference' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>49. Depersonalization/derealization:</span>
                    <textarea id='txtDepersonalizationDerealization' name='txtDepersonalizationDerealization' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>50. Hallucination (A/V/T): </span>
                    <textarea id='txtHallucination' name='txtHallucination' className='add-only'></textarea>

                    <p className='w-750'><h4>PTSD:</h4></p>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>1. Trauma: </span>
                    <textarea id='txtTrauma' name='txtTrauma' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>2. Flashbacks:</span>
                    <textarea id='txtFlashBacks' name='txtFlashBacks' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>3. Nightmares: </span>
                    <textarea id='txtNightmares' name='txtNightmares' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>4. Arousal:</span>
                    <textarea id='txtArousal' name='txtArousal' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>5. Dissociation: </span>
                    <textarea id='txtDissociation' name='txtDissociation' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>6. Re-experiencing:</span>
                    <textarea id='txtExperiencing' name='txtExperiencing' className='add-only'></textarea>
                </p>

                <p className='w-750'><h4>DTO/DTS:</h4></p>




                <p className='w-750'>
                    <span className='eleHeader'>51. Suicidal thoughts/attempts: </span>
                    <textarea id='txtSuicidalThoughtsAttempts' name='txtSuicidalThoughtsAttempts' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>52. Self-harming behaviors: </span>
                    <textarea id='txtSelfHarmingBehaviors' name='txtSelfHarmingBehaviors' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>53. Homicidal thoughts: Denies</span>
                    <textarea id='txtHomicidalThoughtsDenies' name='txtHomicidalThoughtsDenies' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>54. Harming animals: Denies</span>
                    <textarea id='txtHarmingAmimalsDenies' name='txtHarmingAmimalsDenies' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>55. Fire setting: Denies</span>
                    <textarea id='txtFireSettingDenies' name='txtFireSettingDenies' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>56. Access to guns/weapons: Denies </span>
                    <textarea id='txtAccessToGunsWeponsDenies' name='txtAccessToGunsWeponsDenies' className='add-only'></textarea>
                </p>

                <p className='w-750'><h4>OBJECTIVE</h4>
                    <br />
                    Appearance: appearing stated age wearing clean, casual clothing appropriate for situation.
                    No signs of injury on exposed tissue. Not in acute distress or substance use withdrawal.</p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Height:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Weight:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                        <input type='text' id='txtHeight' name='txtHeight' className='add-only'/> </td>
                        <td className='w-375'>
                        <input type='text' id='txtWeight' name='txtWeight' className='add-only'/> </td>
                    </tr>
                </table>

                <p className='w-750'>Orientation (x4): Alert and oriented to person, place, and time. <br />
                    Memory: Remote and recent intact evidenced during assessment. <br />
                    Concentration: Attention and concentration are conversationally adequate <br />
                    Behavior: Pt. is cooperative and engaged. Good eye contact <br />
                    Mood: Euthymic <br />
                    Affect: Congruent, smiles appropriately, displays full affective range. <br />

                    Psychomotor: Pt. sits calmly in their seat during the assessment. No abnormal movements
                    noted, including tremor. Fine and gross motor movement are unremarkable. Gait is normal.
                    Speech: Speech is fluent English with normal prosody, tone, and language.
                    Thought Process: Thought form is linear and logical <br />

                    Thought Content: Goal-directed for improved mental health. Associations are
                    unremarkable. Thought content is devoid of overt delusion, paranoia, ideas of reference,
                    obsessions/compulsions, phobic thoughts, derealizations, and preoccupation. Patient did
                    not appear to respond to nor be preoccupied by internal stimuli during interview. Patient
                    denies active suicidal, homicidal, or assaultive ideation, intent, plan, or passive wish. <br />
                    Insight: Fair <br />
                    Judgment: Fair
                </p>

                <p className='w-750'><h4>DIAGNOSES</h4></p>

                <p className='w-750'>
                    <span className='eleHeader'>Given:</span>
                    <textarea id='txtGiven' name='txtGiven' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Provisional:</span>
                    <textarea id='txtProvisional' name='txtProvisional' className='add-only'></textarea>
                    <br />

                    Risk: No DTS/DTO. Crisis plan reviewed for the patient to seek emergency psychiatric
                    care if having extreme mood changes and/or impulsivity, suicidal and/or homicidal intent,
                    and/or onset of psychosis. </p>

                <p className='w-750'><h4>TREATMENT PLAN</h4></p>

                <p className='w-750'>
                    <span className='eleHeader'>Medications:</span>
                    <textarea id='txtMedications' name='txtMedications' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Pharmacy:</span>
                    <textarea id='txtPharmacy' name='txtPharmacy' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Labs:</span>
                    <textarea id='txtLabs' name='txtLabs' className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Psychotherapy: </span>
                    <textarea id='txtPsychotherapy' name='txtPsychotherapy' className='add-only'></textarea> <br />

                    Nonpharmacological recommendations: Exercise 30 min daily, practice mindfulness and
                    journaling. <br />

                    Follow up: sooner if needed. <br />

                    Plan Discussed with Patient: Target symptoms, medications and potential side effects, and
                    treatment risks and benefits were discussed and reviewed with patient. Specifically,
                    information about medication indication, dosages, frequencies, and alternative options for
                    pharmacotherapy were discussed.  <br />

                    Patient cautioned not to drive, use heavy machinery, or combine sedating medications or
                    alcohol with current medication regimen.
                    <br />
                    Patient verbalized understanding and consented to treatment plan and has the capacity to
                    understand and accept the plan. Patient was given the opportunity to ask questions about
                    mental health and treatment plan and answers provided.</p>











            </div>
        </form >
    )
}